import { ListItemText, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { ICONS } from '@/assets/icons';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import Iconify from '@/components/Iconify';

export const SelectSx: SxProps<Theme> = {
  mb: 2,
  width: '100%',
  '& .MuiSelect-select': {
    typography: 'body2',
    display: 'flex',
    alignItems: 'center',
  },
};

export const DropdownIcon = (props: any) => <Iconify {...props} icon={ICONS.CHEVRON_DOWN} width={20} height={20} />;

export const NumberInputSx: SxProps<Theme> = {
  '.MuiFormHelperText-root': {
    ml: '8px !important',
  },
};

export const StyledListItemText = ({ action, secondary }: { action: ReactNode; secondary?: ReactNode }) => (
  <>
    <ListItemText primary={action} />
    {['string', 'number'].includes(typeof secondary) ? (
      <PTypography variant="body2" color="secondary" sx={{ pl: 1 }}>
        {secondary}
      </PTypography>
    ) : (
      secondary
    )}
  </>
);
